import Cookies from "js-cookie";
import { FiTruck, FiRepeat, FiAward } from "react-icons/fi";
import { ImStack } from "react-icons/im";

// internal import
import Employeesavaibility from "../../components/Dashboard/Employeesavaibility";
import HignlighterCard from "../../components/Dashboard/HignlighterCard";
import InterviewCard from "../../components/Dashboard/InterviewCard";
import TopPerformers from "../../components/Dashboard/TopPerformers";
import UpcommingInterviews from "../../components/Dashboard/UpcommingInterviews";
import GeneralChartCard from "../../components/Dashboard/GeneralChartCard";
import ProjectDashboard from "./ProjectDashboard";
import Card from "../../components/Dashboard/Card";
import DashboardService from "../../services/DashboardService";
import useAsync from "../../hooks/useAsync";
import ModalLoading from "../../components/Loading/ModalLoading";


function HrDashboard() {

    const { data, loading } = useAsync(() => DashboardService?.getAllDashboardData());
    let adminInfo;
    if (Cookies.get("adminInfo")) {
        adminInfo = JSON.parse(Cookies.get("adminInfo"));
    };

    const TotalEmployeesChartData = {
        options: {
            align: 'center',
            chart: {
                height: 250,
                type: 'donut',
                align: 'center',
            },
            labels: ['Man', 'Women'],
            dataLabels: {
                enabled: false,
            },
            legend: {
                position: 'bottom',
                horizontalAlign: 'center',
                show: true,
            },
            colors: ['var(--chart-color4)', 'var(--chart-color3)'],
            series: [data?.data?.employee?.men, data?.data?.employee?.women],
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        position: 'bottom'
                    }
                }
            }]
        }
    }

    const TopHiringSourcesChartData = {
        options: {
            series: !loading ? data?.data?.lastYearData?.projects : [],
            chart: {
                type: 'bar',
                height: 300,
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: true
                }
            },
            colors: ['var(--chart-color1)', 'var(--chart-color2)', 'var(--chart-color3)', 'var(--chart-color4)'],
            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            xaxis: {
                categories: !loading ? data?.data?.lastYearData?.months : ['Jan', 'Feb', 'March', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
            },
            legend: {
                position: 'top', // top, bottom
                horizontalAlign: 'right', // left, right
            },
            dataLabels: {
                enabled: false,
            },
            fill: {
                opacity: 1
            }
        }
    }

    const EmployeeInfoChartData = {
    options:{
        series: [{
            name: 'Available',
            data: data?.data?.lastTenDaysAttenance?.data || [],
        }],
            chart: {
            height: 140,
            type: 'line',
            toolbar: {
                show: false,
            }
        },
        grid: {
            show: false,
            xaxis: {
                lines: {
                    show: false
                }
            },   
            yaxis: { 
                lines: {
                    show: false
                }
            }, 
        },
        stroke: {
            width: 4,
            curve: 'smooth',
            colors: ['var(--chart-color2)'],
        },
        xaxis: {
            // type: 'datetime',
            categories:  data?.data?.lastTenDaysAttenance?.date,
            tickAmount: 10,
            // labels: {
            //     formatter: function(value, timestamp, opts) {
            //         return opts.dateFormatter(new Date(timestamp), 'dd MMM')
            //     }
            // }
        },
        
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                gradientToColors: [ "var(--chart-color3)" ],
                shadeIntensity: 1,
                type: 'horizontal',
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100, 100, 100],
            },
        },
        markers: {
            size: 3,
            colors: ["#FFA41B"],
            strokeColors: "#ffffff",
            strokeWidth: 2,
            hover: {
                size: 7,
            }
        },
        yaxis: {
            show: true,
            min: -1,
        }
    }
}

    return (
        <>{loading ? <ModalLoading loading={loading} /> :
            <>
                {adminInfo?.role === "Admin" ?
                    <div className="container-xxl">
                        <div className="row clearfix g-3">
                            <h5><b>Dashboard Overview</b></h5>
                            <div className="row col-md-12  pt-1">
                                <div className="col-md-3">
                                    <Card mode={"black"} loading={false} Icon={FiTruck} title={"Open Tickets"} className={"text-white bg-soft-orange"} count={String(data?.data?.ticketStats?.statusSummary?.Open)} />
                                </div>
                                <div className="col-md-3 ">
                                    <Card mode={"black"} loading={false} Icon={FiRepeat} title={"In Progress Tickets"} className={"text-light bg-sky-blue"} count={String(data?.data?.ticketStats?.statusSummary["In Progress"])} />
                                </div>
                                <div className="col-md-3">
                                    <Card mode={"blacks"} loading={false} Icon={FiAward} title={"Completed Tickets"} className={"text-white bg-emerald-green"} count={String(data?.data?.ticketStats?.statusSummary?.Completed)} />
                                </div>
                                <div className="col-md-3 ">
                                    <Card mode={"black"} loading={false} Icon={ImStack} title={"Total Tickets"} className={"text-light bg-indigo "} count={String(data?.data?.ticketStats?.totalTickets)} />
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-12 col-md-12 flex-column">
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <GeneralChartCard Title="Employees Info" data={EmployeeInfoChartData} />
                                    </div>
                                    <div className="col-md-6">
                                        <Employeesavaibility data={data?.data?.employeeAvailability} />
                                    </div>
                                    <div className="col-md-6">
                                        <GeneralChartCard Title="Total Employees" data={TotalEmployeesChartData} TitleRight={data?.data?.employee?.total} identity="totalemployee" />
                                    </div>
                                    <div className="col-md-12">
                                        <GeneralChartCard Title="Top Project Chart" data={TopHiringSourcesChartData} identity="TopHiringSources" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-12 col-md-12">
                                <div className="row g-3">
                                    <div className="col-md-6 col-lg-6 col-xl-12"><HignlighterCard total={data?.data?.project?.total} /></div>
                                    <div className="col-md-6 col-lg-6 col-xl-12 flex-column">
                                        <InterviewCard value={String(data?.data?.project?.completed)} iconClass="icofont-tick-mark fs-5" label="Completed" chartClass="icofont-chart-bar-graph fs-3 text-muted" />
                                        <InterviewCard value={String(data?.data?.project?.inProgress)} iconClass="icofont-sand-clock fs-5" label="In Progress" chartClass="icofont-chart-line fs-3 text-muted" />
                                        <InterviewCard value={String(data?.data?.project?.open)} iconClass="icofont-holding-hands fs-5" label="Open" chartClass="icofont-chart-line-alt fs-3 text-muted" />
                                    </div>
                                    <div className="col-md-12 col-lg-12 col-xl-12"><UpcommingInterviews data={data?.data} /></div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <TopPerformers data={data?.data} />
                            </div>
                        </div>
                    </div>
                    :
                    <ProjectDashboard />
                }
            </>
        }
        </>
    )
}


export default HrDashboard;